import { render, staticRenderFns } from "./surroundBox3.vue?vue&type=template&id=e4034782&scoped=true"
import script from "./surroundBox3.vue?vue&type=script&lang=js"
export * from "./surroundBox3.vue?vue&type=script&lang=js"
import style0 from "./surroundBox3.vue?vue&type=style&index=0&id=e4034782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4034782",
  null
  
)

export default component.exports